import { Col } from 'components/Col';
import { NewAutoCompleteField } from 'components/NewAutoCompleteField';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import { useContext, useEffect, useMemo } from 'react';
import { getOptionsFromParams } from 'utils/DropdownUtils';
import languageValues from 'utils/LanguageUtils';

const language = languageValues.inputs.cpfsAssessores;
export default function AssessoresPedagogicos() {
  const { state, dispatch, validator, loadAssessores } =
    useContext(ProjetosContext);

  const validation = useMemo(
    () =>
      validator?.getCampoIsValid({
        key: 'cpfsAssessores',
        etapa: EtapaProjeto.infosIniciais,
        helperText: languageValues.inputs.cpfsAssessores.required,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [validator, state.sent]
  );

  useEffect(() => {
    loadAssessores(state.projeto.codigoCooperativa);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.projeto.codigoCooperativa]);

  const options = useMemo(() => {
    return state.options.assessores.options &&
      state.options.assessores.options.length
      ? getOptionsFromParams(state.options.assessores.options, 'cpf', (a) =>
          a.nome.toUpperCase()
        )
      : [];
  }, [state.options.assessores.options]);

  return (
    <Row>
      <Col>
        <NewAutoCompleteField
          disabled={!state.projeto.idEscola || state.disabledFields}
          label={language.label}
          placeholder={language.placeholder}
          loading={state.options.assessores.loading}
          loadingMessage={language.loading}
          options={options}
          value={state.projeto.cpfsAssessores || []}
          multiple
          onChange={(option: { value: string; label: string }[]) => {
            dispatch({
              type: 'setProjeto',
              payload: {
                cpfsAssessores: option?.map((opt) => opt.value) ?? [],
              },
            });
          }}
          error={state.sent && validation?.error}
          helperText={
            state.sent && validation?.error ? validation?.helperText : undefined
          }
        />
      </Col>
    </Row>
  );
}
